export default __webpack_public_path__ + "static/media/helpMangerAlarmAdd.f11b570b.png";